import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "../Header-Footer/Header";
import Footer from "../Header-Footer/Footer";
import DoPendingForBillReports from "./DoPendingForBillReports";
import DoStatus from "./DoStatus";
import BillRegister from "./BillRegister";
import FreightPaymetRegister from "./FreightPaymetRegister";
import PendingFreightPaymet from "./PendingFreightPaymet";
import TdsFreightList from "./TdsFreightList";
import SaleDoList from "./SaleDoList";
import LepsDoList from "./LepsDoList";
import FreightNotApplicableList from "./FreightNotApplicableList";
import DispacthStatus from "./DispacthStatus";
import MonthlyReport from "./MonthlyReport";
import YearlyReport from "./YearlyReport";
import CustomReport from "./CustomReport";

export default function Report() {
  const [searchParams, setSearchParams] = useSearchParams();
  const report = searchParams.get("report");

  // Set a default report if none in URL
  useEffect(() => {
    if (!report) {
      setSearchParams({ report: "do_status" });
    }
  }, [report, setSearchParams]);

  return (
    <>
      <Header Heading="REPORT" />
      <div style={{ width: "100%" }}>
        {/* Render report based on ?report=... */}
        {report === "DispacthStatus" && <DispacthStatus />}
        {report === "FreightNotApplicableList" && <FreightNotApplicableList />}
        {report === "sale_do" && <SaleDoList />}
        {report === "leps_do" && <LepsDoList />}
        {report === "TdsFreightList" && <TdsFreightList />}
        {report === "PendingFreightPaymet" && <PendingFreightPaymet />}
        {report === "FreightPaymetRegister" && <FreightPaymetRegister />}
        {report === "do_status" && <DoStatus />}
        {report === "do_pending_for_bill" && <DoPendingForBillReports />}
        {report === "do_bill_register" && <BillRegister />}
        {report === "MonthlyReport" && <MonthlyReport />}
        {report === "YearlyReport" && <YearlyReport />}
        {report === "CustomFrieghtReport" && <CustomReport/>}
      </div>
      {/* <Footer />  enable only if you want footer */}
    </>
  );
}